import type {MaterialNodeDefinition} from "#material/nodes/base/material/types/definition"
import {materialColorOutput} from "#material/nodes/base/material/validation/io"
import {materialUiSchema} from "#material/nodes/base/material/validation/ui"
import type {MaterialNodeSockets} from "#material/types/material-node-sockets"
import {z} from "zod/v4-mini"
import {color} from "@cm/graph-v3"
import {ExchangeNodeName} from "#material/exchange/node-name"

export interface ColorSockets extends MaterialNodeSockets {
    inputs: {}
    settings: {
        color: "color" // found in inputs: -; found in settings: color; inferred from data: float3
    }
    outputs: {
        color: "color"
    }
}

export const colorDefinition = {
    exchangeFormat: {
        nodeName: ExchangeNodeName.ShaderNodeRGB,
    },
    nodeClass: "Color",
    ui: {
        label: "Color",
        color: "#9e3500",
        items: [
            {name: "color", valueType: "color", label: "Value", output: true},
            {name: "color", valueType: "color", label: "Value", input: false, setting: true, defaultValue: {r: 0.0, g: 0.0, b: 0.0}},
        ],
        support: {
            cycles: true,
            three: true,
        },
    },
    validation: {
        returns: z.strictObject({color: materialColorOutput}),
        parameters: z.strictObject({
            inputs: z.strictObject({}),
            settings: z.strictObject({color: z.optional(color)}),
            ui: materialUiSchema,
        }),
    },
} satisfies MaterialNodeDefinition<ColorSockets>
